import qs from "qs";

export const getQueryParams = (locationSearch = null) =>
  qs.parse(locationSearch !== null ? locationSearch : window.location.search, { ignoreQueryPrefix: true });

export const stringifyQueryParams = parameters => qs.stringify(parameters);
